export class HistoryMultipleReplaceController {
  public itemOldValues: any;
  public itemNewValues: any;
  public oldValue: any;
  public newValue: any;

  constructor() {
    this.itemOldValues = angular.fromJson(this.oldValue);
    this.itemNewValues = angular.fromJson(this.newValue);
  }
}
